import { apiFetch } from './client';
import type { ConversationType, PayBandPosition, PersonDetail, PersonListRow } from '$lib/types';

export interface PersonUpdateBody {
  last_increment_date?: string;
  last_role_change_date?: string;
  pay_band_position?: PayBandPosition;
  department?: string;
  date_of_joining?: string;
}

export interface ConversationBody {
  date: string;
  type: ConversationType;
  conducted_by: number;
  notes?: string;
}

export interface PersonActionBody {
  description: string;
  owner_id: number;
  due_date?: string;
}

// peopleApi backs the Continuity module's People register (Phase 2) —
// every route is admin-only server-side (see internal/api/handlers/
// people.go); the frontend just surfaces the 403.
export const peopleApi = {
  list: () => apiFetch<PersonListRow[]>('/admin/continuity/people'),
  get: (id: number) => apiFetch<PersonDetail>(`/admin/continuity/people/${id}`),
  update: (id: number, body: PersonUpdateBody) =>
    apiFetch<PersonDetail>(`/admin/continuity/people/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  logConversation: (id: number, body: ConversationBody) =>
    apiFetch<PersonDetail>(`/admin/continuity/people/${id}/conversations`, { method: 'POST', body: JSON.stringify(body) }),
  createAction: (id: number, body: PersonActionBody) =>
    apiFetch<PersonDetail>(`/admin/continuity/people/${id}/actions`, { method: 'POST', body: JSON.stringify(body) }),
  // setNotice/cancelNotice back Phase 3's "Someone is leaving" flow (see
  // internal/api/handlers/people.go's SetPersonNotice) — one endpoint,
  // {last_working_day} to set, {cancel:true} to clear.
  setNotice: (id: number, lastWorkingDay: string) =>
    apiFetch<PersonDetail>(`/admin/continuity/people/${id}/notice`, {
      method: 'POST',
      body: JSON.stringify({ last_working_day: lastWorkingDay })
    }),
  cancelNotice: (id: number) =>
    apiFetch<PersonDetail>(`/admin/continuity/people/${id}/notice`, { method: 'POST', body: JSON.stringify({ cancel: true }) })
};
